var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1.02686,
  width: 33,
  height: 33,
  rx: 16.5,
  stroke: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1923 8.6405V11.5204H20.4265C19.7463 11.5204 19.3143 11.6472 19.1314 11.8994C18.896 12.1773 18.7783 12.5695 18.7783 13.074V15.1209H22.0746L21.6427 18.3418H18.7783V26.5269H15.3644V18.3418H12.5V15.1209H15.3644V12.7712C15.3644 11.4573 15.7439 10.4096 16.5023 9.62587C17.3131 8.89342 18.36 8.52686 19.6415 8.52686C20.7142 8.52686 21.5645 8.56497 22.1923 8.6405Z",
  fill: "white"
})));
export default SvgWhiteFacebookIcon;